// extracted by mini-css-extract-plugin
export default {"courseBlock":"Course_courseBlock__DFdr7","title":"Course_title__4k4v4","subTitle":"Course_subTitle__SACLx","img":"Course_img__Fr2qZ","discount":"Course_discount__CjGRC"};